module.exports = __webpack_public_path__ + "static/media/boomplay.119a6401.svg";